<template>
    <div>
        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>

        <div v-else>
        <vue-headful :title="catalog.catalog_name + ' [Safety Data Sheet Catalog] :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/safety-data-sheets`">
                            <i class="fa fa-files-o"></i> Safety Data Sheets
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/safety-data-sheets#catalogs`">
                            Catalogs
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">
                        {{ catalog.catalog_name }}
                    </li>
                </ol>
            </h4>

            <div class="row mb-4">
                <div class="col-xl-8 col-lg-12">
                    <div class="card mb-3">
                        <div class="card-header">
                            <strong>SDS Catalog</strong>

                            <div class="float-sm-right mt-sm-0 mt-3" v-if="canEdit">
                                <router-link :to="`/safety-data-sheets/catalogs/edit/${catalog.id}`" class="btn btn-sm btn-light">
                                    <i class="fa fa-edit"></i> Edit
                                </router-link>
                                <router-link :to="`/safety-data-sheets/catalogs/delete/${catalog.id}`" class="btn btn-sm btn-light">
                                    <i class="fa fa-trash text-danger"></i> Delete
                                </router-link>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row mb-sm-2 mb-1">
                                <div class="col-md-4 text-md-right text-muted">Catalog Name:</div>
                                <div class="col-md-8">
                                    {{ catalog.catalog_name }}
                                </div>
                            </div>
                            <div class="row mb-sm-2 mb-1">
                                <div class="col-md-4 text-md-right text-muted">SDS Count:</div>
                                <div class="col-md-8">
                                    {{ catalog.sds_count }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-4 col-lg-12">

                </div>
            </div>

            <b-tabs class="nav-tabs-top mb-4">
                <b-tab active>
                    <template slot='title'>
                        <i class="fa fa-files-o"></i> Safety Data Sheets ({{ sheet_count }})
                    </template>
                    <b-card-body>
                        <safety-data-sheets-list assetType="SafetyDataSheetCatalog" :assetId="parseInt(id)" @sdsListCount="setSdsCount"></safety-data-sheets-list>
                    </b-card-body>
                </b-tab>
                <b-tab>
                    <template slot='title'>
                        <i class="fa fa-building"></i> Jobsites ({{ jobsites.length }})
                    </template>
                    <b-card-body>
                        <v-client-table ref="catalogJobsiteTable" :data="jobsites" :columns="columns" :options="options">
                            <template slot="JobsiteId" slot-scope="props">

                            </template>
                            <template slot="JobsiteName" slot-scope="props">
                                <router-link :to="`/jobsites/view/${props.row.JobsiteId}`"><span v-if="props.row.JobsiteId">{{ props.row.JobsiteNumber }} -</span> {{ props.row.JobsiteName }}</router-link>
                            </template>
                            <template slot="IsActive" slot-scope="props">
                                <label class="badge badge-success" v-if="props.row.IsActive == 1">Active</label>
                                <label class="badge badge-warning" v-else>Inactive</label>
                            </template>
                        </v-client-table>
                    </b-card-body>
                </b-tab>
            </b-tabs>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                id: this.$route.params.id,
                userTimezone: this.$store.state.user.timezone,
                catalog: {},
                jobsites: [],
                sheet_count: null,

                columns: [
                    //'JobsiteId',
                    'JobsiteName',
                    'IsActive'
                ],
                options: {
                    headings: {
                        JobsiteId: 'Actions',
                        JobsiteName: 'Jobsite',
                        IsActive: 'Active',
                    },
                    columnsDropdown: false,
                    uniqueKey: 'JobsiteId',
                },
            }
        },

        computed: {

            canEdit(){
                //Check for manager
                if(this.$root.hasPermission('safety.data_sheets.manage'))
                {
                    return true;
                }

                //Default Defense
                return false;
            },

        },

        methods: {

            getCatalog() {
                //Get the data
                this.$http
                    .get('/safety-data-sheets/catalogs/view/' + this.id)
                    .then(response => {
                        //Set all the data
                        this.catalog = response.data.catalog;
                        this.jobsites = response.data.jobsites;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            setSdsCount(count){
                //Set the count
                this.sheet_count = count;
            },

        },
        mounted() {
            //Get the Safety Data Sheet
            this.getCatalog();
        }
    }
</script>
